// files
import "./Banner.css"

const Banner = () => {
  return (
    <article id="banner">
      <div>
        <h1>Things We Love</h1>
        <h2>Let's Meet, Talk, and Grow Together</h2>
      </div>
    </article>
  )
}
export default Banner;